import { GetSingleIRLDoc } from '../redux/documentsSlice';
import { createVdrDocumentObjectUrl } from './vdrDocumentDownloadUtils';

/**
 * Resolve a workstream document to a URL the PDF viewer can load.
 * Uses the API file stream when storage is Azure (private / VNet — no direct blob access).
 */
export async function fetchAuthenticatedIrlDocumentUrl(dispatch, { wsId, docId, workstream }) {
    const ws = Number(wsId);
    const doc = Number(docId);
    if (!Number.isFinite(ws) || !Number.isFinite(doc)) {
        throw new Error('missing_ids');
    }

    const response = await dispatch(GetSingleIRLDoc({ wsId: ws, docId: doc }));
    if (response?.type !== 'IRLDOC/getSingleIRLDoc/fulfilled') {
        throw new Error('fetch_failed');
    }

    const fileLike = response?.payload?.data;
    if (!fileLike?.document) {
        throw new Error('no_url');
    }

    if (fileLike.document.includes('.blob.core.windows.net')) {
        return createVdrDocumentObjectUrl(
            { ...fileLike, id: fileLike.id ?? doc },
            { workstream: workstream ?? { id: ws } },
        );
    }

    return fileLike.document;
}
